var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailScheduler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 12.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.9,10.7H1c-.2,0-.3-.1-.3-.3V1c0-.1,0-.2,.2-.2L7.1,5.7c1,.7,2.3,.7,3.3,0L16.5,.8c0,0,.2,.1,.2,.2V5.7c0,.2,.2,.4,.4,.4s.4-.2,.4-.4V1c0-.6-.5-1-1-1H1C.5,0,0,.5,0,1V10.4c0,.6,.5,1,1,1H10.9c.2,0,.4-.2,.4-.4,0-.2-.2-.4-.4-.4h0Zm-.9-5.6c-.7,.5-1.7,.5-2.4,0L2.2,.8H15.3l-5.4,4.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.5,5.5c-1.9,0-3.5,1.5-3.5,3.5s1.5,3.5,3.5,3.5,3.5-1.5,3.5-3.5c0-1.9-1.6-3.5-3.5-3.5Zm0,6.2c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.8,8.6h-.9v-1.5c0-.2-.2-.4-.4-.4s-.4,.2-.4,.4v1.9c0,.2,.2,.4,.4,.4h1.3c.2,0,.4-.2,.4-.4s-.2-.4-.4-.4h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailScheduler);
export default __webpack_public_path__ + "static/media/email-scheduler.2dc5a5a09e4b64713f2ee1146574fcb4.svg";
export { ForwardRef as ReactComponent };